/**
 * The plan somebody chose on the website, carried through signing in.
 *
 * The website's pricing buttons open `/signup?plan=growth`. Signing in can
 * leave the tab -- a mailed link opens a new one, Google and Microsoft are a
 * round trip -- so the choice is kept in this browser's storage until an
 * organisation is made, then spent on a checkout. It is a convenience: lost,
 * the organisation starts on Free and Settings still offers every plan.
 */

import { isPaidPlan, type PaidPlanId } from "@utuwrk/core";

const KEY = "utuwrk.plan";

/** Keeps `?plan=` from a /signup address, if it names a paid plan. */
export function rememberPlan(location: { pathname: string; search: string }): void {
  if (location.pathname.replace(/\/+$/, "") !== "/signup") return;
  const plan = new URLSearchParams(location.search).get("plan");
  try {
    if (isPaidPlan(plan)) window.localStorage.setItem(KEY, plan);
    else window.localStorage.removeItem(KEY);
  } catch {
    // Storage refused (a private window): the organisation starts on Free.
  }
}

/** The plan chosen, once, and forgotten as it is read. */
export function takePlan(): PaidPlanId | null {
  try {
    const plan = window.localStorage.getItem(KEY);
    window.localStorage.removeItem(KEY);
    return isPaidPlan(plan) ? plan : null;
  } catch {
    return null;
  }
}
